var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 5.0625C2.75 3.9375 3.66406 3 4.8125 3H11.9375C12.6406 3 13.25 3.60938 13.25 4.3125V11.0625C13.25 11.6016 12.9219 12.0469 12.5 12.2578V13.875H12.6875C12.9922 13.875 13.25 14.1328 13.25 14.4375C13.25 14.7656 12.9922 15 12.6875 15H4.625C3.57031 15 2.75 14.1797 2.75 13.125C2.75 13.0781 2.75 13.0078 2.75 12.9375V5.0625ZM4.625 12.375C4.20312 12.375 3.875 12.7266 3.875 13.125C3.875 13.5469 4.20312 13.875 4.625 13.875H11.375V12.375H4.625ZM3.875 11.4141C4.08594 11.3203 4.34375 11.25 4.625 11.25H11.9375C12.0312 11.25 12.125 11.1797 12.125 11.0625V4.3125C12.125 4.21875 12.0312 4.125 11.9375 4.125H4.8125C4.27344 4.125 3.875 4.54688 3.875 5.0625V11.4141ZM6.3125 5.625H10.4375C10.7422 5.625 11 5.88281 11 6.1875C11 6.51562 10.7422 6.75 10.4375 6.75H6.3125C5.98438 6.75 5.75 6.51562 5.75 6.1875C5.75 5.88281 5.98438 5.625 6.3125 5.625ZM6.3125 7.5H10.4375C10.7422 7.5 11 7.75781 11 8.0625C11 8.39062 10.7422 8.625 10.4375 8.625H6.3125C5.98438 8.625 5.75 8.39062 5.75 8.0625C5.75 7.75781 5.98438 7.5 6.3125 7.5Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.f85da0bd32977667bd308a46c3b10660.svg";
export { ForwardRef as ReactComponent };